// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VideoCameraAddOutlinedSvg from "@fishx/icons-svg/es/asn/VideoCameraAddOutlined";
import FishxIcon from '../components/FishxIcon';

var VideoCameraAddOutlined = function VideoCameraAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraAddOutlinedSvg
  }));
};

VideoCameraAddOutlined.displayName = 'VideoCameraAddOutlined';
export default React.forwardRef(VideoCameraAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VideoCameraAddOutlined.js
// module id = 4374
// module chunks = 0